import { create } from "zustand";
import { persist } from "zustand/middleware";

// types
import { Generic } from "types/filters-store.types";

type ExportColumnsStore = {
  exportColumns: Generic[];

  setExportColumns: (columns: Generic[]) => void;
  clear: () => void;
};

const useExportColumnStore = create(
  persist<ExportColumnsStore>(
    (set) => ({
      exportColumns: [],

      setExportColumns: (exportColumns) => {
        set(() => ({
          exportColumns,
        }));
      },

      clear: () => {
        set(() => ({
          exportColumns: [],
        }));
      },
    }),

    // cache data to (default) localStorage
    {
      name: "export-columns-store-v1.16",
    }
  )
);

export default useExportColumnStore;
